export const buildMessageElementId = (messageId: string) =>
  `message-${messageId}`
